import CryptoJS from 'crypto-js';

export function setUserInfo(data) {
    sessionStorage.setItem("userInfo", CryptoJS.AES.encrypt(JSON.stringify(data), "tataTechonologies").toString());
}

export function getUserInfo() {
    var bytes = CryptoJS.AES.decrypt(sessionStorage.getItem("userInfo"), 'tataTechonologies');
    let userObj = bytes.toString(CryptoJS.enc.Utf8);
    return (JSON.parse(userObj));
}

export function setDashboard(data) {
    sessionStorage.setItem("Dashboards", CryptoJS.AES.encrypt(JSON.stringify(data), "tataTechonologies").toString());
}
export function getDashboard() {
    var bytes = CryptoJS.AES.decrypt(sessionStorage.getItem("Dashboards"), 'tataTechonologies');
    let dash = bytes.toString(CryptoJS.enc.Utf8);
    return (JSON.parse(dash));
}

export function encryptPlainText(data) {
    const key = 'a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6'; // Replace with a secure secret key
    const encryptedData = CryptoJS.AES.encrypt(data, key).toString();
    // const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
    return encryptedData;
}
export function getPlainText(data) {
    //temp test
    // let temp = "yvJQ58hc0XoF/R7+VfacJY2eLMtK/ev3LAJ/tivUEvNC1RPQqtHptFTB3RRq4gi+";
    // let decodedString = (CryptoJS.AES.decrypt(temp, 'a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6').toString(CryptoJS.enc.Utf8));
    // console.log(decodedString);
//    let temp = "U2FsdGVkX18k65/pbo8I4poCSZekNd3ZbTdfSffRk+L6YcjCgTsRM1iqD1d7JJq/cKP9Z5bt1OQSnx+nMhCi+g==";
//     decodedString = (JSON.parse(decodedString)).split(':');
    // decodedString = decodedString.split(':');
//     let inputData = {
//         emailID: decodedString[0],
//         password: decodedString[1]
//     };
//     console.log(inputData);
    //actual code
    var bytes = CryptoJS.AES.decrypt(data, 'a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6');
    let dash = bytes.toString(CryptoJS.enc.Utf8);
    
    return (JSON.parse(dash).data);
}